// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/utils/format-money.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/utils/src/format-money.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo malla-vpn-app
//     node fleet/fleet.ts check --repo malla-vpn-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
const CENTS_PER_UNIT = 100;
const DECIMAL_PLACES_LARGE = 2;

/**
 * Formats an integer amount of minor units (cents) as a decimal money string.
 * Pure: callers prepend their own currency symbol from the i18n layer.
 * `formatMoney(2320)` → "23.20".
 */
export function formatMoney(cents: number | null | undefined): string {
  const value = (cents ?? 0) / CENTS_PER_UNIT;
  return value.toFixed(DECIMAL_PLACES_LARGE);
}

/** Parses a decimal money string ("23.50") into integer cents (2350). */
export function parseMoneyToCents(input: string): number {
  const n = Number.parseFloat(input.replace(",", "."));
  if (Number.isNaN(n)) {
    return 0;
  }
  return Math.round(n * CENTS_PER_UNIT);
}
